import { ManualEntry } from './manualEntry';

export class AuditData{
    changedAttribute : any;
    newValue : any;
    oldValue : any;
}

export class AuditTrail{
changedBy	: string;
messageText : AuditData[];
dateChanged	: Date;
actionPerformed: string;
actionPerformedOn: string;
primaryKey: any;
}

export class AuditMaterial{
    changedAttribute: string;
    newValue : any;
    oldValue : any;
    materialName : string;
}

export class TransactionAuditTrail{
    changedBy : string;
    dateChanged : Date;
    actionPerformed : string;
    actionPerformedOn : string;
    primaryKey : any;
    generalInformation : AuditData[];
    material : AuditMaterial[];
    statusChange : AuditData[];
}

export class EditManulEntry{
    fullName : string;
    city : string;
    office : string;
    floor : string;
    gate : string;
    transportationMode : string;
    taxiProvider : string;
    vehicleType : string;
    rideType : string;
    vehicleNumber : string;
    others : string;
    exitDate : string;
    exitTime : string;
    shiftSupervisor : string;
    employeeType:string;
}

export class UpdateManualData{
    employeeCheckOutData : ManualEntry;
    auditTrailData : AuditTrail[];
}